import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "subheading" }
const _hoisted_2 = { class: "ml-1 font-weight-medium" }

import { ref, computed, watch, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import type {
  ResourceDictPropertyOptionValue,
  ResourceDictPropertyValue,
  ResourceFilterPropertyValue,
} from '@/venit/services/model/techpubs-cms';
import ResourceManagementService from './resource-management.service';
import StringUtils from '@/shared/utils/string-utils.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'resource-properties-edit-row-component',
  props: {
    allPropertiesDictionary: {},
    resourceProperty: {},
    usedCodes: {}
  },
  emits: ["filterRowRemoved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const resourcesManagementService = inject<() => ResourceManagementService>('resourceService')!;
const { locale } = useI18n();

const selectedPropertyType = ref<ResourceDictPropertyValue | null>(null);
const selectedPropertyOptions = ref<ResourceDictPropertyOptionValue[]>([]);
const selectedPropertyAllPossibleOptions = ref<ResourceDictPropertyOptionValue[]>([]);
const selectedPropertyAllPossibleOptionsCodes = ref<string[]>([]);
const isLoading = ref(false);
const search = ref('');

const stringToValueOption = (val: string): ResourceDictPropertyOptionValue => {
  if (selectedPropertyType.value?.valueOpen) {
    return { code: val, defaultName: val, translations: [] };
  } else {
    return selectedPropertyType.value?.propertyOptions.find(opt => opt.code === val) as ResourceDictPropertyOptionValue;
  }
};

const recalculateOptions = () => {
  if (!props.resourceProperty || props.resourceProperty.propertyCode == null) {
    selectedPropertyType.value = null;
    selectedPropertyOptions.value = [];
    selectedPropertyAllPossibleOptions.value = [];
    return;
  }
  selectedPropertyType.value = props.allPropertiesDictionary.find(prop => prop.code === props.resourceProperty.propertyCode) || null;
  if (selectedPropertyType.value) {
    selectedPropertyAllPossibleOptions.value = selectedPropertyType.value.propertyOptions;
    selectedPropertyAllPossibleOptionsCodes.value = selectedPropertyType.value.propertyOptions.map(opt => opt.code);
    selectedPropertyOptions.value = props.resourceProperty.options.map(pv => stringToValueOption(pv));
  }
};

const updateFilterSelectedPropertyOptions = () => {
  props.resourceProperty.options = selectedPropertyOptions.value.filter(spo => !!spo).filter(spo => spo.code).map(spo => spo.code);
};

const onUpdatePropertyOptions = () => {
  if (!selectedPropertyType.value) return;
  if (!selectedPropertyType.value.valueOpen || !selectedPropertyType.value.code || StringUtils.isBlank(search.value)) return;
  isLoading.value = true;
  resourcesManagementService().listPropertyOptions(selectedPropertyType.value.code, search.value, 50).then(response => {
    selectedPropertyAllPossibleOptions.value = response.data;
    selectedPropertyAllPossibleOptionsCodes.value = response.data.map(opt => opt.code);
    isLoading.value = false;
  });
};

const onRemovePropertyFilter = () => emit('filterRowRemoved', props.resourceProperty);

const onSelectedSearchPropertyChange = () => {
  if (selectedPropertyType.value) props.resourceProperty.propertyCode = selectedPropertyType.value.code;
};

const propertyDescription = (property: ResourceDictPropertyValue) => {
  const translation = property.translations?.find(t => t.langCode === locale.value);
  return translation?.name || property.defaultName;
};


watch(selectedPropertyOptions, (val, prev) => {
  if (val.length === prev.length) return;
  selectedPropertyOptions.value = val.map(v => {
    if (typeof v === 'string') {
      const obj = stringToValueOption(v);
      selectedPropertyAllPossibleOptions.value.push(obj);
      return obj;
    }
    return v as ResourceDictPropertyOptionValue;
  });
  updateFilterSelectedPropertyOptions();
});

watch(search, onUpdatePropertyOptions);
watch(() => props.resourceProperty.propertyCode, () => recalculateOptions());
watch(() => props.allPropertiesDictionary, () => recalculateOptions());

recalculateOptions();

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_row, { justify: "start" }, {
    default: _withCtx(() => [
      _createCommentVNode(" \n      Jeden wiersz składa się z nazwy property i jego wartości.\n      Otwarte wartości - można w pisać wartość z ręki\n      Zamknięte wartości - wybór z listy zdefiniowanych wcześniej opcji\n    "),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6",
        class: "d-flex align-center ga-2"
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" wybór jednego property z listy "),
          _createVNode(_component_v_select, {
            itemref: "item",
            modelValue: selectedPropertyType.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((selectedPropertyType).value = $event)),
              onSelectedSearchPropertyChange
            ],
            label: _ctx.$t('admin-resources.filter.property.row.chooseProperty'),
            items: __props.allPropertiesDictionary,
            "item-title": item => propertyDescription(item),
            "item-value": "code",
            "return-object": "",
            rules: [
          v => !!v || _ctx.$t('admin-resources.edit.properties.validation.propertyRequired'),
          v => !v || (props.usedCodes ?? []).filter(c => c === v.code).length <= 1 || _ctx.$t('admin-resources.edit.properties.validation.propertyDuplicate'),
        ],
            "hide-details": "auto",
            density: "compact"
          }, null, 8 /* PROPS */, ["modelValue", "label", "items", "item-title", "rules"]),
          (selectedPropertyType.value?.description)
            ? _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "small",
                color: "grey"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-information-outline", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })), [
                [_directive_tooltip, selectedPropertyType.value.description]
              ])
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "5",
        class: "d-flex align-center ga-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_combobox, {
            modelValue: selectedPropertyOptions.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPropertyOptions).value = $event)),
            label: _ctx.$t('admin-resources.filter.property.row.chooseOptionLabel'),
            items: selectedPropertyAllPossibleOptions.value,
            "item-title": "defaultName",
            "item-value": "code",
            loading: isLoading.value,
            search: search.value,
            "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
            multiple: "",
            placeholder: _ctx.$t('admin-resources.filter.property.row.startTypingSearch'),
            "hide-no-data": !search.value,
            rules: [v => !selectedPropertyType.value || v.length > 0 || _ctx.$t('admin-resources.edit.properties.validation.valueRequired')],
            "hide-details": "auto",
            density: "compact",
            autocomplete: "off"
          }, {
            "no-data": _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('admin-resources.filter.property.row.addCustomOption')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(search.value), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            selection: _withCtx(({ item, index }) => [
              _createElementVNode("span", null, _toDisplayString(item.raw.defaultName) + _toDisplayString(index < selectedPropertyOptions.value.length - 1 ? ',\u00a0' : ''), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "label", "items", "loading", "search", "placeholder", "hide-no-data", "rules"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "1",
        class: "d-flex align-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            onClick: onRemovePropertyFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-delete", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})